import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana81Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1455_8941)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M563.811 742.65L573.723 780.317L603.46 771.396L593.548 733.729L563.811 742.65Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M534.073 751.572L563.811 742.65L573.723 780.318L544.977 789.239L534.073 751.572Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M553.901 704.984L563.814 742.651L593.551 733.73L582.647 696.062L553.901 704.984Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M524.16 712.916L553.897 704.986L563.81 742.654L534.073 751.575L524.16 712.916Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M542.995 667.317L553.899 704.984L582.645 696.063L571.741 659.387L542.995 667.317Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M524.164 712.914L553.902 704.984L542.998 667.316L514.252 676.238L524.164 712.914Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M503.346 637.581L514.249 676.24L542.995 667.319L533.083 628.66L503.346 637.581Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M561.829 620.727L571.741 659.385L542.995 667.315L533.083 628.657L561.829 620.727Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M551.914 583.062L561.826 620.73L533.08 628.66L522.177 590.992L551.914 583.062Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M493.433 599.915L503.345 637.583L533.082 628.661L522.179 590.994L493.433 599.915Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M482.526 562.244L493.43 599.912L522.176 590.99L511.272 554.314L482.526 562.244Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M542.002 545.396L551.914 583.064L522.177 590.994L511.273 554.318L542.002 545.396Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M531.099 507.727L542.002 545.394L511.274 554.315L501.361 516.648L531.099 507.727Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M472.614 524.578L482.527 562.246L511.273 554.316L501.36 516.648L472.614 524.578Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M521.186 471.051L531.099 507.727L501.362 516.648L491.449 478.981L521.186 471.051Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M462.705 486.908L472.618 524.576L501.364 516.646L491.451 478.979L462.705 486.908Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M511.273 431.4L521.186 471.05L490.457 478.98L481.536 440.322L511.273 431.4Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M451.799 448.252L462.702 486.911L490.457 478.981L481.536 440.322L451.799 448.252Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M500.367 393.734L511.271 431.402L480.542 440.323L470.63 402.656L500.367 393.734Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M441.887 410.582L451.799 448.25L480.545 440.32L470.633 402.652L441.887 410.582Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M490.459 357.059L500.371 393.735L470.634 402.656L460.722 364.989L490.459 357.059Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M431.974 372.916L441.886 410.583L470.632 402.654L460.72 364.986L431.974 372.916Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M479.555 319.389L490.458 357.056L460.721 364.986L450.809 327.319L479.555 319.389Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M421.071 335.25L431.975 372.917L460.721 364.988L450.809 327.32L421.071 335.25Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M469.644 280.732L479.556 319.391L450.81 327.321L439.906 289.654L469.644 280.732Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M411.159 297.586L421.072 335.253L450.809 327.323L439.905 289.656L411.159 297.586Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M458.741 243.062L469.645 280.73L439.908 289.651L429.004 250.992L458.741 243.062Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M400.257 259.917L411.161 297.584L439.907 289.655L429.003 250.996L400.257 259.917Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M450.807 211.346L458.737 243.066L428.999 250.996L419.087 213.328C421.73 212.337 428.405 210.157 433.956 209.364C439.507 208.571 447.503 210.355 450.807 211.346Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}       
      d="M390.942 226.843L400.276 259.939L429.03 251.014L418.1 213.329C415.33 213.874 410.364 215.047 405.224 217.289C400.084 219.531 393.232 224.263 390.942 226.843Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1455_8941" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1455_8941" transform="matrix(0.00135965 0 0 0.00180254 -3.29213 -0.712663)"/>
    </pattern>
    <image id="image0_1455_8941" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};